import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css';
import {
  post
} from './http/api'


import Vant from 'vant';
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
console.log(VueAMap)
// 常用css
import './assets/css/main.css';
Vue.use(Vant);
Vue.prototype.post = post
Vue.config.productionTip = false
VueAMap.initAMapApiLoader({
  key: '9205d1bf16ea4d0fd0d91ef53e2e42c4',
  plugin: ['AMap.Geolocation'],
  v: '1.4.4'
});

Vue.mixin({

  methods: {

    go(path) {
      this.$router.push({
        path: path
      })
    }
  },

})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')